module.exports = __webpack_public_path__ + "img/Actu.fr_logo_2020.7fb6c235.svg";